import { useEffect, useMemo, useState } from 'react'
import debounce from 'lodash/debounce'
import { LAB_ORDER_ATTRIBUTES } from '../../../lib/const'
import { useCheckout } from '../useCheckout'

const PLACEHOLDER = 'Write your note here.'
const MAX_LENGTH = 1000

const ORDER_NOTES_DEBOUNCE_MS = 800

const OrderNotes = () => {
  const { order, updateOrder } = useCheckout()
  const persisted = order?.data?.attributes?.orderNotes ?? ''
  const [value, setValue] = useState(persisted)

  useEffect(() => {
    setValue(persisted)
  }, [persisted])

  const debouncedPatch = useMemo(
    () =>
      debounce((next) => {
        updateOrder({
          type: LAB_ORDER_ATTRIBUTES.orderNotes,
          order_note: next === '' ? null : next,
          value: true,
        })
      }, ORDER_NOTES_DEBOUNCE_MS),
    [updateOrder],
  )

  useEffect(() => {
    return () => {
      debouncedPatch.flush()
      debouncedPatch.cancel()
    }
  }, [debouncedPatch])

  const handleChange = (event) => {
    const next = event.target.value
    setValue(next)
    debouncedPatch(next)
  }

  return (
    <div className="input-container" style={{ maxWidth: '460px' }}>
      <div className="label-container">
        <div className="label-subcontainer">
          <div className="sub-label-form">order note</div>
        </div>
      </div>
      <div className="form-block-input w-form">
        <div className="form-input select-field area">
          <div className="select-field-wrapper area">
            <textarea
              className="text-field-2 font-size-14 area w-input"
              name="orderNotes"
              maxLength={MAX_LENGTH}
              placeholder={PLACEHOLDER}
              value={value}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderNotes
